package er.prateek.crossly.ui.screens.crossword

import androidx.compose.runtime.Stable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.geometry.Rect

/**
 * The three things a first-time player actually needs on the play screen,
 * taught in the order they play: read a clue, pick a square, place a letter.
 */
enum class PlayCoachStep {
    HINT,
    CELL,
    LETTERS,
    ;

    val index: Int get() = ordinal

    val isLast: Boolean get() = this == LETTERS

    fun next(): PlayCoachStep? = entries.getOrNull(ordinal + 1)

    companion object {
        val count: Int get() = entries.size
    }
}

/**
 * On-screen bounds of the three coached regions, in root coordinates — the same
 * space [LetterDragState] uses, so a hole punched in the overlay lines up with
 * the real clue bar, board and rack on every window size.
 */
@Stable
class CoachMarkAnchors {
    var clue by mutableStateOf(Rect.Zero)
    var board by mutableStateOf(Rect.Zero)
    var letters by mutableStateOf(Rect.Zero)

    fun holeFor(step: PlayCoachStep, selectedCell: Rect = Rect.Zero): Rect = when (step) {
        PlayCoachStep.HINT -> clue
        PlayCoachStep.CELL -> if (selectedCell.isEmpty) board else selectedCell
        PlayCoachStep.LETTERS -> letters
    }
}
